// Sons des surprises cachées (easter eggs) des événements du site, fabriqués avec
// Web Audio : aucun fichier à charger. Ils ne jouent qu'après un clic du visiteur.

let ctx = null;
function audio() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

function noiseBuffer(ac, seconds) {
  const buffer = ac.createBuffer(1, Math.ceil(ac.sampleRate * seconds), ac.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
  return buffer;
}

function envelope(ac, node, t, attack, hold, release, peak) {
  node.gain.setValueAtTime(0.0001, t);
  node.gain.exponentialRampToValueAtTime(peak, t + attack);
  node.gain.setValueAtTime(peak, t + attack + hold);
  node.gain.exponentialRampToValueAtTime(0.0001, t + attack + hold + release);
}

// Sortie commune avec un léger écho (plus inquiétant pour le rire).
function output(ac, echo = 0) {
  const master = ac.createGain();
  master.gain.value = 0.55;
  master.connect(ac.destination);
  if (echo > 0) {
    const delay = ac.createDelay(1);
    delay.delayTime.value = 0.23;
    const feedback = ac.createGain();
    feedback.gain.value = echo;
    const wet = ac.createGain();
    wet.gain.value = 0.5;
    master.connect(delay);
    delay.connect(feedback);
    feedback.connect(delay);
    delay.connect(wet);
    wet.connect(ac.destination);
  }
  return master;
}

// Une syllabe chantée (« ha », « ho ») : souffle puis voyelle filtrée par deux formants.
function syllable(ac, out, t, { f0, f1, f2, length, gain = 0.5, slide = 0.85, breath = true }) {
  const osc = ac.createOscillator();
  osc.type = "sawtooth";
  osc.frequency.setValueAtTime(f0, t);
  osc.frequency.exponentialRampToValueAtTime(f0 * slide, t + length);
  const vibrato = ac.createOscillator();
  const depth = ac.createGain();
  vibrato.frequency.value = 6;
  depth.gain.value = f0 * 0.03;
  vibrato.connect(depth);
  depth.connect(osc.frequency);
  const voice = ac.createGain();
  envelope(ac, voice, t, 0.02, length * 0.45, length * 0.55, gain);
  [[f1, 6], [f2, 9]].forEach(([freq, q], i) => {
    const band = ac.createBiquadFilter();
    band.type = "bandpass";
    band.frequency.value = freq;
    band.Q.value = q;
    const g = ac.createGain();
    g.gain.value = i === 0 ? 1.4 : 0.8;
    osc.connect(band);
    band.connect(g);
    g.connect(voice);
  });
  voice.connect(out);
  osc.start(t);
  vibrato.start(t);
  osc.stop(t + length + 0.05);
  vibrato.stop(t + length + 0.05);
  if (breath) {
    const n = ac.createBufferSource();
    n.buffer = noiseBuffer(ac, 0.08);
    const hp = ac.createBiquadFilter();
    hp.type = "highpass";
    hp.frequency.value = 1200;
    const ng = ac.createGain();
    envelope(ac, ng, t - 0.04, 0.01, 0.02, 0.04, gain * 0.25);
    n.connect(hp);
    hp.connect(ng);
    ng.connect(out);
    n.start(Math.max(ac.currentTime, t - 0.04));
  }
}

function tone(ac, out, t, freq, length, { type = "sine", gain = 0.3, attack = 0.005, endFreq } = {}) {
  const osc = ac.createOscillator();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t);
  if (endFreq) osc.frequency.exponentialRampToValueAtTime(endFreq, t + length);
  const g = ac.createGain();
  envelope(ac, g, t, attack, 0, length, gain);
  osc.connect(g);
  g.connect(out);
  osc.start(t);
  osc.stop(t + attack + length + 0.05);
}

function noise(ac, out, t, length, { type = "bandpass", freq = 1500, q = 1, gain = 0.3 } = {}) {
  const n = ac.createBufferSource();
  n.buffer = noiseBuffer(ac, length + 0.05);
  const f = ac.createBiquadFilter();
  f.type = type;
  f.frequency.value = freq;
  f.Q.value = q;
  const g = ac.createGain();
  envelope(ac, g, t, 0.003, 0, length, gain);
  n.connect(f);
  f.connect(g);
  g.connect(out);
  n.start(t);
}

const SOUNDS = {
  // « Mouahahaha » grave qui descend, avec écho et un bourdon en dessous.
  laugh(ac) {
    const out = output(ac, 0.35);
    const t0 = ac.currentTime + 0.05;
    tone(ac, out, t0, 55, 2.6, { gain: 0.25, attack: 0.4, type: "sine" });
    syllable(ac, out, t0, { f0: 150, f1: 450, f2: 800, length: 0.45, gain: 0.55, slide: 0.95, breath: false });
    const has = [175, 168, 160, 150, 140, 128, 115];
    has.forEach((f0, i) => syllable(ac, out, t0 + 0.55 + i * 0.2, { f0, f1: 750, f2: 1150, length: 0.15, gain: 0.5 - i * 0.03 }));
  },
  hohoho(ac) {
    const out = output(ac, 0.15);
    const t0 = ac.currentTime + 0.05;
    [0, 0.42, 0.84].forEach((dt) => syllable(ac, out, t0 + dt, { f0: 105, f1: 480, f2: 880, length: 0.3, gain: 0.6, slide: 0.9 }));
  },
  // Début de « Vive le vent » aux clochettes, avec les grelots du traîneau.
  bells(ac) {
    const out = output(ac, 0.1);
    const t0 = ac.currentTime + 0.05;
    const E = 659, G = 784, C = 523, D = 587;
    const notes = [[E, 0], [E, 0.18], [E, 0.36], [E, 0.72], [E, 0.9], [E, 1.08], [E, 1.44], [G, 1.62], [C, 1.8], [D, 2.0], [E, 2.2]];
    notes.forEach(([f, dt]) => {
      tone(ac, out, t0 + dt, f, 0.5, { gain: 0.2 });
      tone(ac, out, t0 + dt, f * 2.76, 0.25, { gain: 0.06 });
      tone(ac, out, t0 + dt, f * 5.4, 0.12, { gain: 0.03 });
    });
    for (let i = 0; i < 18; i++) noise(ac, out, t0 + i * 0.15, 0.06, { type: "highpass", freq: 6000, gain: 0.08 });
  },
  // Bouchon de champagne puis les bulles.
  pop(ac) {
    const out = output(ac);
    const t0 = ac.currentTime + 0.03;
    noise(ac, out, t0, 0.05, { freq: 1200, q: 1.5, gain: 0.7 });
    tone(ac, out, t0, 700, 0.12, { endFreq: 160, gain: 0.5 });
    for (let i = 0; i < 25; i++) tone(ac, out, t0 + 0.2 + Math.random() * 1.4, 2500 + Math.random() * 3000, 0.03, { gain: 0.04 });
  },
  chime(ac) {
    const out = output(ac, 0.2);
    const t0 = ac.currentTime + 0.03;
    [1047, 1319, 1568, 2093].forEach((f, i) => tone(ac, out, t0 + i * 0.12, f, 0.8, { gain: 0.15 }));
  },
  chirp(ac) {
    const out = output(ac);
    const t0 = ac.currentTime + 0.03;
    noise(ac, out, t0, 0.08, { freq: 3000, q: 2, gain: 0.3 });
    [0.25, 0.42, 0.59].forEach((dt) => tone(ac, out, t0 + dt, 2200, 0.09, { endFreq: 3600, gain: 0.18 }));
  },
  blub(ac) {
    const out = output(ac);
    const t0 = ac.currentTime + 0.03;
    [0, 0.16, 0.3, 0.5].forEach((dt, i) => tone(ac, out, t0 + dt, 260 + i * 40, 0.12, { endFreq: 700 + i * 60, gain: 0.25 }));
  },
  fanfare(ac) {
    const out = output(ac, 0.1);
    const t0 = ac.currentTime + 0.03;
    [[392, 0, 0.15], [523, 0.16, 0.15], [659, 0.32, 0.15], [784, 0.48, 0.6]].forEach(([f, dt, len]) => {
      tone(ac, out, t0 + dt, f, len, { type: "triangle", gain: 0.22, attack: 0.02 });
      tone(ac, out, t0 + dt, f * 2, len, { type: "square", gain: 0.03, attack: 0.02 });
    });
  },
  saber(ac) {
    const out = output(ac);
    const t0 = ac.currentTime + 0.03;
    tone(ac, out, t0, 90, 1.4, { type: "sawtooth", gain: 0.12, attack: 0.15 });
    tone(ac, out, t0, 180, 0.6, { type: "sawtooth", endFreq: 120, gain: 0.08, attack: 0.05 });
    noise(ac, out, t0, 0.35, { type: "bandpass", freq: 900, q: 3, gain: 0.2 });
  },
  sparkle(ac) {
    const out = output(ac, 0.15);
    const t0 = ac.currentTime + 0.03;
    noise(ac, out, t0, 0.04, { freq: 2000, gain: 0.4 });
    for (let i = 0; i < 8; i++) tone(ac, out, t0 + 0.05 + i * 0.06, 1500 + Math.random() * 2500, 0.15, { gain: 0.06 });
  },
};

export function playSeasonSound(name) {
  try {
    const ac = audio();
    if (ac && SOUNDS[name]) SOUNDS[name](ac);
  } catch { /* son impossible : la surprise reste visuelle */ }
}
